
  import React from "react"
  import Component from "/Users/Finn/Code/lvng/src/layouts/index.js"
  import data from "/Users/Finn/Code/lvng/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js